window.ptab = promokit.tab({
  el: '#section2-tab',
  initActive: 1, //2차 오픈 시 1, alert 삭제!
});

export default {
  id: '#section2'
};



// WEBPACK FOOTER //
// ./src/js/bingo/section-2.js